// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { eachHourOfInterval as fn } from "../eachHourOfInterval.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const eachHourOfIntervalWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default eachHourOfIntervalWithOptions;
